// TiptapEditor.jsx
import React, { useEffect } from 'react';
import '../../styles/tiptap.css'
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableHeader from '@tiptap/extension-table-header';
import TableCell from '@tiptap/extension-table-cell';
import { TextSelection } from 'prosemirror-state';
import TextAlign from '@tiptap/extension-text-align';
import FontSize from './tip_tap_font';

const TiptapEditor = ({ initialContent, onChange }) => {
 const editor = useEditor({
  extensions: [
    StarterKit.configure({
      // enable text-align on supported nodes
      paragraph: {
        HTMLAttributes: {
          style: '', // allow style attribute
        },
      },
    }),FontSize,
    TextAlign.configure({
      types: ['heading', 'paragraph'], // where alignment is allowed
    }),
    Link.configure({ openOnClick: false }),
    Table.configure({
      resizable: true,
      HTMLAttributes: {
        style: 'width: 100%; border-collapse: collapse;',
      },
    }),
    TableRow,
    TableHeader,
    TableCell,
  ],
    content: initialContent || '<p>Start typing...</p>',
    editorProps: {
  handleKeyDown(view, event) {
    const { state, dispatch } = view;
    const { from } = state.selection;

    if (event.key === ' ') {
      const space = '\u00A0'; // non-breaking space
      const tr = state.tr.insertText(space, from);
      tr.setSelection(TextSelection.create(tr.doc, from + 1));
      dispatch(tr);
      return true;
    }

    if (event.key === 'Tab') {
      const tab = '    '; // 4 spaces
      const tr = state.tr.insertText(tab, from);
      tr.setSelection(TextSelection.create(tr.doc, from + tab.length));
      dispatch(tr);
      return true;
    }

    return false;
  }
},
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      onChange?.(html);
    },
  });
console.log(editor)
  // Handle update when `initialContent` changes
useEffect(() => {
  if (editor && initialContent && editor.getHTML() !== initialContent) {
    editor.commands.setContent(initialContent);
  }
}, [initialContent, editor]);




  if (!editor) return null;

  const insertTable = () => {
    const rows = parseInt(prompt('Number of rows:', 3), 10);
    const cols = parseInt(prompt('Number of columns:', 3), 10);
    if (rows > 0 && cols > 0) {
      editor.chain().focus().insertTable({ rows, cols, withHeaderRow: true }).run();
    }
  };
const changeFontSize = (delta) => {
  if (!editor) return;

  const { state } = editor;
  const { from } = state.selection;
  const { doc } = state;

  let currentSize = 16; // default fallback

  const $pos = doc.resolve(from);
  const marks = $pos.marks();

  const fontSizeMark = marks.find(mark => mark.type.name === 'fontSize');
  if (fontSizeMark) {
    currentSize = parseInt(fontSizeMark.attrs.size || 16, 10);
  }

  const newSize = Math.max(8, Math.min(currentSize + delta, 72)); // clamp between 8–72
  editor.chain().focus().setFontSize(newSize).run();
};


  return (
    <div className="editor-wrapper">
      <div className="toolbar">
        <button onClick={() => editor.chain().focus().toggleBold().run()}>Bold</button>
        <button onClick={() => editor.chain().focus().toggleItalic().run()}>Italic</button>
        <button onClick={() => editor.chain().focus().toggleBulletList().run()}>• List</button>
        <button onClick={() => editor.chain().focus().setLink({ href: 'https://example.com' }).run()}>
          Add Link
        </button>
        <button onClick={insertTable}>Insert Table</button>
         <button onClick={() => editor.chain().focus().setTextAlign('left').run()}>Align Left</button>
        <button onClick={() => editor.chain().focus().setTextAlign('center').run()}>Center</button>
        <button onClick={() => editor.chain().focus().setTextAlign('right').run()}>Align Right</button>
        <button onClick={() => editor.chain().focus().setTextAlign('justify').run()}>Justify</button>
        <button onClick={() => changeFontSize(-2)}>A-</button>
        <button onClick={() => changeFontSize(2)}>A+</button>
        <select
            onChange={(e) => {
              const size = parseInt(e.target.value, 10);
              if (editor && size) {
                editor.chain().focus().setFontSize(size).run();
              }
            }}
            defaultValue=""
          >
            <option value="" disabled>Select font size</option>
            {[10, 12, 14, 16, 18, 20, 24, 28, 32, 36].map((size) => (
              <option key={size} value={size}>{size}px</option>
            ))}
          </select>
      </div>
      <EditorContent editor={editor} className="editor-content" />
    </div>
  );
};

export default TiptapEditor;
